(function ($, Drupal, once) {
  Drupal.behaviors.percentItems = {
    attach: function (context) {

      once(
          'percent-animation',
          '.paragraph--type--percent-item .field--name-field-percent',
          context
      ).forEach((percentField) => {

        const target = parseFloat(percentField.textContent);

        if (isNaN(target) || target <= 0) {
          return;
        }

        const duration = 1800;
        const startTime = performance.now();
        const isInteger = target % 1 === 0;
        percentField.textContent = isInteger ? '0' : '0.00';

        function animate(currentTime) {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);
          const current = progress * target;

          if (isInteger) {
            percentField.textContent = Math.floor(current);
          } else {
            percentField.textContent = current.toFixed(2);
          }

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            percentField.textContent = isInteger ? target : target.toFixed(2);
          }
        }
        requestAnimationFrame(animate);
      });
    },
  };
})(jQuery, Drupal, once);